import React from "react"
import {useNavigate} from "react-router-dom"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import Page from "@/layouts/Page"
import FileSection from "@/components/files/FilesSection"

function EditFiles() {
   const navigate = useNavigate()
   const id = window.location.pathname.split("/editFiles/")[1]
   return (
      <Page>
         <header>
            <ArrowBackIcon
               className="font-bold mb-7 cursor-pointer mt-5"
               onClick={() => navigate(-1)}
            />
         </header>
         <h1 className="text-center font-bold text-blue text-2xl mb-4">Editar Archivos</h1>
         <FileSection id={id} />
         <div className="flex justify-center">
            <button
               onClick={() => {
                  navigate(-1)
               }}
               className="rounded bg-green p-2 mb-5 text-white font-bold w-[200px]"
            >
               Guardar Cambios
            </button>
         </div>
      </Page>
   )
}

export default EditFiles
